module.exports = __webpack_public_path__ + "img/Icon_Bin.0050ea15.svg";